import { FilterSchema } from '@/api';
import { SearchParams } from '@/routes';

export const createAddressBedrijfFilter = (search: SearchParams) => {
  const filter: FilterSchema[] = [];

  Object.entries({
    Plaatsnaam: search.plaats,
    Straatnaam: search.straat,
    Postcode: search.postcode,
    Locatienummer: search.locatienummer,
    Naam: search.query,
  }).forEach(([field, value]) => {
    if (value) {
      filter.push({
        field,
        op: 'like',
        value: `%${value.replace(/\s+/g, '%')}%`,
      });
    }
  });

  return filter;
};
